/**
 * @generated SignedSource<<b324f1c35d06fa7bcb1fc071680efae8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BrainSearchMoreActionsButtonFragment$data = {
  readonly contentUsage: {
    readonly id: string;
  } | null;
  readonly hasViewerBookmarked: boolean;
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"BookmarkButtonBrainSearchFragment" | "DeleteBrainSearchButtonFragment" | "usePermissionsFragment">;
  readonly " $fragmentType": "BrainSearchMoreActionsButtonFragment";
};
export type BrainSearchMoreActionsButtonFragment$key = {
  readonly " $data"?: BrainSearchMoreActionsButtonFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"BrainSearchMoreActionsButtonFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BrainSearchMoreActionsButtonFragment",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasViewerBookmarked",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ContentUsage",
      "kind": "LinkedField",
      "name": "contentUsage",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "usePermissionsFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DeleteBrainSearchButtonFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BookmarkButtonBrainSearchFragment"
    }
  ],
  "type": "BrainSearch",
  "abstractKey": null
};
})();

(node as any).hash = "6bbd1ad5a6a603dfcac85a2c0f2a9d3f";

export default node;
